module.exports = __webpack_public_path__ + "static/img/1.4dc6069.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/1.png
// module id = rUPR
// module chunks = 0